export default __webpack_public_path__ + "static/storyboard-3763f721684a2e56682eeeb4daac15b3.png";